module.exports = __webpack_public_path__ + "static/2-2e37dc187fcc5a8c13f65d7dc3214edc.jpg";